/**
 * The code a manually added form carries from the moment it exists on the
 * page (Step 2 of docs/plans/2026-09-11-store-form-code.md, 2026-09-14).
 *
 * The badge shows a stored code, else the code derived from the name. So
 * "taken" is every form's badge value, stored or derived, and the new form
 * gets its own natural code unless that is taken, in which case the shared
 * rule's letter alternative — the same rule the server applies when it first
 * persists a form without a code, so page and server agree.
 */
import { assignCodeForNewForm } from '../../../../functions/src/utils/formCodeAssignment';
import { deriveFormCode } from '../../../../functions/src/utils/formCode';

export function codeForNewForm(
  existing: Array<{ name: string; code?: string }>,
  name: string,
): string {
  const taken = (existing ?? []).map((f) => String(f?.code ?? '').trim() || deriveFormCode(f?.name));
  return assignCodeForNewForm(name, taken);
}
